import { render } from "./Popup.vue?vue&type=template&id=639ce5f3&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=639ce5f3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-639ce5f3"

export default script